import React from 'react'
import CenterModal from '../../../components/Modals/center-modal';
import { ReactComponent as SuccessIcon } from '../../../assets/sucessful.svg'

const EmployeeSignupModal = ({ show, closeModal }) => {

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!max-w-[450px]  [&>*]:!border-0 [&>*]:!rounded-lg [&>*]:!overflow-hidden' backDropClassName={''}>
            <div className='!p-6'>
                <div className='flex flex-col items-center justify-center'>
                    <SuccessIcon />
                    <h3 className='text-xl font-semibold !mt-6'>
                        Welcome {localStorage.getItem('name')}
                    </h3>

                    <p className='mb-0 mt-2.5 text-center'>Welcome to Propacity! We’re excited to have you join our community </p>
                    <button className='pr-btn w-full font-semibold !mt-4' onClick={closeModal}>Done</button>
                </div>
            </div>
        </CenterModal>
    )
}

export default EmployeeSignupModal